import Vue from "vue";
import VueRouter from "vue-router";
import { getUserDetailsLocalStorage } from "@/utils/functions.js";
import { checkifLoggedIn } from "@/utils/functions";

// Components
import ForgotPassword from "@/pages/ForgotPassword.vue";
import OrderTracking from "@/pages/OrderTracking.vue";
import ErrorPage from "@/pages/client/ErrorPage.vue";

// Layout Imports
import Default from "@/layouts/Default.vue";
import AdminDefault from "@/layouts/AdminDefault.vue";
import ClientDefault from "@/layouts/ClientDefault.vue";
import ConsigneeDefault from "@/layouts/ConsigneeDefault.vue";
import SupportDefault from "@/layouts/SupportDefault.vue";

// Route Imports
import AdminRoutes from "@/router/admin";
import ClientRoutes from "@/router/client";
import ConsigneeRoutes from "@/router/consignee";
import supportUserRoutes from "@/router/supportUser";
// Generalized component Imports
import Login from "@/pages/login/Login.vue";

const routes = [
  {
    path: "/",
    redirect: { name: "base-app" },
  },
  {
    path: "/app",
    component: Default,
    name: "base-app",
    redirect: (to) => {
      if (checkifLoggedIn()) {
        let user = getUserDetailsLocalStorage();
        if (
          ["account_manager", "system_admin", "support_user"].indexOf(
            user.role
          ) > -1
        ) {
          return { name: "admin" };
        } else if (user.role == "consignee_user") {
          return { name: "consignee" };
        } else if (user.role == "support_user") {
          return { name: "support_user" };
        } else {
          return { name: "client" };
        }
      } else {
        return { name: "login" };
      }
    },
    children: [
      {
        path: "login",
        component: Login,
        name: "login",
      },
      {
        path: "admin",
        component: AdminDefault,
        children: AdminRoutes,
        name: "admin",
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
        redirect: () => {
          return { name: "admin-dashboard" };
        },
      },
      {
        path: "client",
        name: "client",
        component: ClientDefault,
        children: ClientRoutes,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
        redirect: (to) => {
          return { name: "client-dashboard" };
        },
      },
      {
        path: "consignee",
        name: "consignee",
        component: ConsigneeDefault,
        children: ConsigneeRoutes,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
        redirect: () => {
          return { name: "consignee-dashboard" };
        },
      },
      {
        path: "support-user",
        name: "support_user",
        component: SupportDefault,
        children: supportUserRoutes,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
        redirect: () => {
          return { name: "support-dashboard" };
        },
      },
      {
        path: "forgot-password",
        component: ForgotPassword,
        name: "forgot-password",
      },
      {
        path: ":pathMatch(.*)*",
        name: "error-page",
        component: ErrorPage,
      },
    ],
  },
  {
    path: "/order-tracking/:id",
    component: OrderTracking,
    name: "order-tracking",
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: (to) => {
      if (!to.name || to.name != "order-tracking") {
        // return to;
      }
    },
  },
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  routes: routes,
});

export default router;
